import React from 'react';
import icon from '../../../../assets/dbs/db_dblp.png';

const DblpIcon = () => (
    <div>
        <img style = {{height: 25, paddingBottom:5, paddingRight: 5}} src={icon} alt="dblp"/>
    </div>
);
export default DblpIcon;